











import {Component, Prop, Vue} from 'vue-property-decorator';
import AgeLabel from '../AgeLabel.vue';

@Component({
    components: {AgeLabel}
})
export default class ChartPoint extends Vue {
    @Prop({
        default: null
    })
    public config!: any;

    @Prop({
        default: null
    })
    public point!: any;

    public fillStyleForPoint(line: any) {
        return {
            left: (((line.x - this.config.xOffset) / this.config.xLength) * 100) + '%',
            bottom: (((line.y - this.config.yOffset) / this.config.yLength) * 100) + '%'
        }
    }

}
